let BASE_URL

if (process.env.NODE_ENV === "development") {
    // 开发环境
    BASE_URL = "/admin";
} else {
    // 生产环境
    BASE_URL = "https://iip-admin.huiyeai.com/admin"; // 外网地址
    // BASE_URL = "/admin"; // 内网地址
}

export default BASE_URL;
